<a
    *appHasPermissionId="permissionList.operationRead; else justNameTemplateRef"
    [routerLink]="['', 'operation', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
